import React from "react";
import {Dialog} from "@mui/material";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {CloseIcon, DialogContent, DialogText, DialogTitle, IconWrapper, RecheckButton, Wrapper} from "./styles";
import close from '../../../../assets/images/reservation/close.svg';
import sandClock from '../../../../assets/images/reservation/sand-clock.svg';

const SessionEndedDialog = props => {
    const {open, onRecheck, onClose} = props;
    const {t} = useTranslation();

    return <Dialog open={open} onClose={onClose} maxWidth="lg" PaperProps={{
        style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            boxSizing: 'border-box'
        },
    }}>
        <Wrapper>
            <CloseIcon src={close} onClick={onClose}/>
            <IconWrapper>
                <img src={sandClock} alt="session timeout"/>
            </IconWrapper>
            <DialogContent>
                <DialogTitle>{t('OOPS')}</DialogTitle>
                <DialogText>
                    <span className="bold">{t('SESSION_EXPIRED')}</span>
                    <span>{t('SESSION_EXPIRED_INFO')}</span>
                    <span>{t('SESSION_EXPIRED_INFO_LINE_2')}</span>
                </DialogText>
                <RecheckButton onClick={onRecheck}>{t('RECHECK_AVAILABILITY')}</RecheckButton>
            </DialogContent>
        </Wrapper>
    </Dialog>
}

SessionEndedDialog.propTypes = {
    open: PropTypes.bool,
    onRecheck: PropTypes.func,
    onClose: PropTypes.func,
}

export default SessionEndedDialog;
